module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "modulebtn",
    class: _vm.buttonModClass,
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-325d02f4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/modulebutton/ModuleButton.vue
// module id = 6ee31c6994779f5f4454
// module chunks = 0